module.exports = __webpack_public_path__ + "static/media/hint.8bbc515c.svg";